import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VAppBar,{attrs:{"app":"","clipped-left":""}},[_c(VAppBarNavIcon,{staticClass:"grey--text",on:{"click":_vm.toggleDrawer}}),_c(VToolbarTitle,{staticClass:"pr-5"},[_c('span',{staticClass:"grey--text font-weight-light"},[_vm._v("Allianz.")]),_c('span',{staticClass:"font-italic"},[_vm._v("Reith.de")])]),_c(VSpacer)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }